import { action } from 'easy-peasy';
import { IActionSetTriageRequests } from '../types';

const setTriageRequests: IActionSetTriageRequests = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.requests.length;

  state.triageRequests.total = payload.total;
  state.triageRequests.requests = payload.requests;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setTriageRequests;
